/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod_H2Inputs */

const es_landing_mod_h2 = /** @type {(inputs: Landing_Mod_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un solo hogar para cualquier barco de España.`)
};

const gl_landing_mod_h2 = /** @type {(inputs: Landing_Mod_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un só fogar para calquera barco de España.`)
};

const en_landing_mod_h2 = /** @type {(inputs: Landing_Mod_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One home for every boat in Spain.`)
};

/**
* | output |
* | --- |
* | "One home for every boat in Spain." |
*
* @param {Landing_Mod_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod_h2 = /** @type {((inputs?: Landing_Mod_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod_h2(inputs)
	if (locale === "en") return en_landing_mod_h2(inputs)
	return es_landing_mod_h2(inputs)
});